import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { TillsPage } from '../../../features/pos/tills-page'

export const Route = createFileRoute('/_app/pos/tills')({
  staticData: { crumb: 'posTills' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'pos.manage'),
  component: TillsPage,
})
